import { useState, useEffect } from "react";
import { useIntl } from "react-intl";

import { paymentLink, quickTransfer } from "../../services/animationIcons";
import { Button, AnimateIcon, Icon } from "../../components";
import "./SliderItem.scss";

export const SliderItem = ({
  picture,
  title,
  description,
  service = "paymentlink", // paymentlink, quicktransfer
  ...otherProps
}) => {
  let [isOpen, setIsOpen] = useState(false);
  const btnText = useIntl().formatMessage({ id: "sliderItem.link" });
  const btnTextCerrar = useIntl().formatMessage({ id: "sliderItem.close" });

  // item style width
  let sizeIcon = "20px";
  const [width, setWidth] = useState(0);

  if (window.innerWidth > 1200) {
    sizeIcon = "36px";
  }
  useEffect(() => {
    if (window.innerWidth > 1200) {
      const calcWidth =
        (Math.min(1376 - 32, document.body.clientWidth - 32) / 12) * 5 - 32;
      const minWidth = 555;
      if (calcWidth > minWidth) {
        setWidth(calcWidth);
      } else {
        setWidth(minWidth);
      }
    } else {
      const calcWidth = (document.body.clientWidth / 6) * 3;
      const minWidth = 240;
      if (calcWidth > minWidth) {
        setWidth(calcWidth);
      } else {
        setWidth(minWidth);
      }
    }
  }, []);
  return (
    <div
      className={`slider-item ${isOpen && "active"} ${service}`}
      style={{ backgroundImage: `url(${picture})`, width: `${width}px` }}
      {...otherProps}
    >
      {isOpen && <div className={"degradedTop" + service}></div>}
      <div className="slider-item-container">
        <div className="title">{title}</div>
        {isOpen && (
          <div className="center">
            <div className="service">
              <div className="icon">
                {service === "paymentlink" ? (
                  <AnimateIcon json={paymentLink} size={sizeIcon} />
                ) : (
                  <AnimateIcon json={quickTransfer} size={sizeIcon} />
                )}
              </div>

              <div className="text">
                {service === "paymentlink" ? "Payment Links" : "Quick Transfer"}
              </div>
            </div>
            <div
              className="description"
              dangerouslySetInnerHTML={{ __html: description }}
            ></div>
            <br />
            <br />

            <br />
          </div>
        )}
      </div>
      {isOpen && <div className={"degradedBottom" + service}></div>}
      <div className="btn btn-card-useCases">
        <Button
          onHandleClick={() => setIsOpen(!isOpen)}
          color={isOpen && "white"}
          bgColor={
            isOpen
              ? service === "paymentlink"
                ? "#262255"
                : "#5c2a48"
              : "#EFEFEF"
          }
          isOpen={isOpen}
          bgHoverColor={service === "paymentlink" ? "#262255" : "#5c2a48"}
        >
          {!isOpen && (
            <>
              <Icon name="plus"></Icon>
              <span className="hide-xs margin-rightDesktopButton">
                {btnText}
              </span>
            </>
          )}
          {isOpen && (
            <>
              <span className="">-</span>

              <span className="btnCloseCard">{btnTextCerrar}</span>
            </>
          )}
        </Button>
      </div>
      <div className="back"></div>
    </div>
  );
};
